// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.list-item[data-v-d4ce8794] {\r\n    padding: 10px;\r\n    border-bottom: 1px solid #eee;\n}\n.list-item[data-v-d4ce8794]:hover {\r\n    background-color: #f5f5f5;\n}\n.selected-item[data-v-d4ce8794] {\r\n    margin-top: 20px;\r\n    padding: 10px;\r\n    background-color: #e3f2fd;\r\n    border-radius: 4px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
